if (!customElements.get('product-tab-grid')) {
  customElements.define('product-tab-grid', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.panels = [...this.querySelectorAll('[data-product-panel]')];
      const tablist = this.querySelector('[role="tablist"]');
      const multiple = this.panels.length > 1;
      this.tabs = this.panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'product-tab-grid__tab';
        tab.id = `${panel.id}-tab`;
        tab.textContent = panel.dataset.tabTitle;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', multiple ? 'tabpanel' : 'region');
        if (multiple) panel.setAttribute('aria-labelledby', tab.id);
        else panel.setAttribute('aria-label', panel.dataset.tabTitle);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => this.selectTab(index, true), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectTab(next, true);
          this.tabs[next].focus({ preventScroll: true });
        }, options);
        return tab;
      });
      tablist.replaceChildren(...this.tabs);
      tablist.hidden = !multiple;
      // 配置从 1 开始计数，删除 Tab 后越界或无效的配置回退到第一个。
      const defaultTab = Number(this.dataset.defaultTab);
      const defaultIndex = Number.isInteger(defaultTab) && defaultTab >= 1 && defaultTab <= this.panels.length
        ? defaultTab - 1
        : 0;
      this.selectTab(defaultIndex);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-product-add]');
        if (button) this.addToCart(button);
      }, options);
      // 编辑器选中隐藏 Tab 内的卡片时，同步展示所属面板。
      document.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-product-panel]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) this.selectTab(index);
      }, options);
    }

    disconnectedCallback() {
      this.events?.abort();
    }

    selectTab(index, scroll = false) {
      this.tabs.forEach((tab, current) => {
        const selected = index === current;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[current].hidden = !selected;
      });
      if (scroll) this.tabs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    }

    async addToCart(button) {
      if (button.disabled) return;
      const status = button.closest('.product-tab-grid__card').querySelector('[role="status"]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      let added = false;
      try {
        // 沿用主题的抽屉、购物车数量和主购物车刷新逻辑。
        const renderer = customElements.get('product-card')?.prototype;
        if (!renderer?.renderContents || !renderer?.getSectionsToRender) {
          throw new Error('Cart is not ready. Please try again.');
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: button.dataset.variantId, quantity: Number(button.dataset.quantity) || 1 }],
            sections: renderer.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add item to cart.');
        added = true;
        renderer.renderContents(result);
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: result.items ? result.items[0] : result },
        }));
      } catch (error) {
        // 已加购但抽屉刷新失败时，不提示重试加购，避免重复购买。
        status.textContent = added ? 'Item added. Please open your cart to view it.' : error.message || 'Unable to add item to cart.';
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
